import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../action/ActionArgs'

@InputType()
export class CloneLogisticServiceArgs extends ActionArgs {
  @Field(() => String)
  logisticId: string
}
